module.exports = __webpack_public_path__ + "img/domestic-1981-workshop.02c1ae7e.jpg";